import {
    get,
    postGQL,
    endpoints,
} from '../../api';

import {
    queryGetPlanDetails,
    queryCreateSubscription,
    queryUpdateSubscription,
    queryFinalize3DSecure,
    queryPreviewSubscription,
} from '../billing/queries';
import {
    queryCancelSubscription,
} from './queries';
import axios from "axios";

export function connectVars (input) {
    return { i: { ...input, type: 'connect' } };
}

const INTEGRATION_DETAILS_URL =
    'https://d27vx6ekipa712.cloudfront.net/assets/integration/connect/integration_details.json';

function toFeaturesArray (features) {
    if (Array.isArray(features)) return features;
    if (typeof features !== 'string' || !features.trim()) return [];
    return features.split('\n').map((line) => line.trim()).filter(Boolean);
}

function toDetailsMap (list) {
    const map = {};
    (Array.isArray(list) ? list : []).forEach((entry) => {
        const key = (entry.name || '').trim().toLowerCase();
        if (!key) return;
        map[key] = {
            subtitle: entry.subtitle || '',
            summary: entry.summary || '',
            features: toFeaturesArray(entry.features),
        };
    });
    return map;
}

export async function apiGetIntegrationDetails () {
    try {
        const res = await axios(INTEGRATION_DETAILS_URL, );
        return toDetailsMap(res.data);
    } catch {
        return {};
    }
}

export function apiBrowseConnectIntegrations ({ token, traceId, action }) {
    return get(
        endpoints().connectBrowse,
        { token, traceId, action, returnOnError: true }
    );
}

export function apiGetConnectToken ({ token, traceId, action }) {
    return get(
        endpoints().connectToken,
        { token, traceId, action, returnOnError: true }
    );
}

export async function apiCancelSubscription ({ input, token, traceId }) {
    window.envStore.errorStore.gqlAction = 'cancelSubscription';
    return postGQL(
        endpoints().billing,
        queryCancelSubscription(connectVars(input)),
        { token, traceId, action: 'connectCancelSubscription', returnOnError: true }
    );
}

export async function apiGetConnectCurrentPlan ({ token, traceId }) {
    return get(
        endpoints().connectCurrentPlan,
        { token, traceId, action: 'connectGetCurrentPlan', returnOnError: true }
    );
}

export async function apiGetConnectPlanDetails ({ input, token, traceId }) {
    window.envStore.errorStore.gqlAction = 'getPlanDetails';
    return postGQL(
        endpoints().billing,
        queryGetPlanDetails(connectVars(input)),
        { token, traceId, action: 'connectGetPlanDetails', returnOnError: true }
    );
}

export async function apiPreviewSubscription ({ input, token, traceId }) {
    window.envStore.errorStore.gqlAction = 'previewSubscription';
    return postGQL(
        endpoints().billing,
        queryPreviewSubscription(connectVars(input)),
        { token, traceId, action: 'connectPreviewSubscription', returnOnError: true }
    );
}

export async function apiCreateSubscription ({ input, token, traceId }) {
    window.envStore.errorStore.gqlAction = 'createSubscription';
    return postGQL(
        endpoints().billing,
        queryCreateSubscription(connectVars(input)),
        { token, traceId, action: 'connectCreateSubscription', returnOnError: true }
    );
}

export async function apiUpgradeSubscription ({ input, token, traceId }) {
    window.envStore.errorStore.gqlAction = 'upgradeSubscription';
    return postGQL(
        endpoints().billing,
        queryUpdateSubscription(connectVars(input)),
        { token, traceId, action: 'connectUpgradeSubscription', returnOnError: true }
    );
}

export async function apiFinalize3DSecure ({ input, token, traceId }) {
    window.envStore.errorStore.gqlAction = 'finalize3DSecureSubscription';
    return postGQL(
        endpoints().billing,
        queryFinalize3DSecure(connectVars(input)),
        { token, traceId, action: 'connectFinalize3DSecureSubscription' }
    );
}
